module.exports = __webpack_public_path__ + "static/media/quoteDefault.afa3ecb1.svg";